var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContacts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4508 27.2479C30.4508 29.0353 29.3908 30.4091 27.5186 31.3633C25.634 32.3238 22.9852 32.8189 20.0077 32.8189C17.0527 32.8189 14.4036 32.1659 12.5112 31.1222C10.6039 30.0702 9.56458 28.6869 9.56458 27.2479C9.56458 21.4804 14.2401 16.8048 20.0077 16.8048C25.7753 16.8048 30.4508 21.4804 30.4508 27.2479Z",
    fill: "#E8F2FD",
    stroke: "#4C5B66",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7943 11.1251C25.7943 12.7352 25.1374 14.4751 24.0634 15.8103C22.9888 17.1463 21.5478 18.0184 20.0077 18.0184C18.4676 18.0184 17.0267 17.1463 15.9521 15.8103C14.8781 14.4751 14.2212 12.7352 14.2212 11.1251C14.2212 7.92925 16.8119 5.33853 20.0077 5.33853C23.2035 5.33853 25.7943 7.92925 25.7943 11.1251Z",
    fill: "#E8F2FD",
    stroke: "#4C5B66",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.436 36.2779C40.436 38.5018 39.113 40.2014 36.8158 41.3722C34.5061 42.5494 31.27 43.152 27.6439 43.152C24.0402 43.152 20.8039 42.3559 18.4864 41.0777C16.154 39.7913 14.8518 38.0822 14.8518 36.2779C14.8518 29.213 20.579 23.4858 27.6439 23.4858C34.7088 23.4858 40.436 29.213 40.436 36.2779Z",
    fill: "#59A5EE",
    stroke: "#4C5B66",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7798 16.6941C34.7798 18.6769 33.9719 20.8135 32.6537 22.4523C31.3349 24.0919 29.5566 25.1744 27.6439 25.1744C25.7311 25.1744 23.9529 24.0919 22.6341 22.4523C21.3159 20.8135 20.5079 18.6769 20.5079 16.6941C20.5079 12.753 23.7028 9.55814 27.6439 9.55814C31.585 9.55814 34.7798 12.753 34.7798 16.6941Z",
    fill: "#59A5EE",
    stroke: "#4C5B66",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.52e17e9cf77b042d7b37a5e974e05373.svg";
export { ForwardRef as ReactComponent };